import { render, staticRenderFns } from "./AndiamoPaiViewComponent.vue?vue&type=template&id=c5894000&scoped=true"
import script from "./AndiamoPaiViewComponent.vue?vue&type=script&lang=js"
export * from "./AndiamoPaiViewComponent.vue?vue&type=script&lang=js"
import style0 from "./AndiamoPaiViewComponent.vue?vue&type=style&index=0&id=c5894000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5894000",
  null
  
)

export default component.exports